<section class="sign-off-time-transfer" data-testid="data-terminal-sign-off-time-transfer">
    @switch (status()) {
        @case (TimeTransferStatus.IDLE) {
            <p data-testid="sign-off-time-transfer-hint">
                {{ 'DC.SIGN_OFF_DIALOG.TIME_TRANSFER.HINT' | translate }}
            </p>
        }
        @case (TimeTransferStatus.ERROR) {
            <hdmui-info-box
                [icon]="'hdmui:exclamationMarkCircled'"
                [backgroundColor]="'error'"
                [background]="'full'"
                data-testid="sign-off-time-transfer-error"
            >
                <p>{{ 'DC.SIGN_OFF_DIALOG.TIME_TRANSFER.ERROR' | translate }}</p>
            </hdmui-info-box>
        }
        @default {
            <div class="sign-off-time-transfer__progress hdmui-p-4">
                <p class="hdmui-mx-0">{{ 'DC.SIGN_OFF_DIALOG.TIME_TRANSFER.PROGRESS_LABEL' | translate }}</p>
                <span class="sign-off-time-transfer__counter" data-testid="sign-off-time-transfer-counter">
                    {{ processed() }}/{{ total() }}
                </span>
                <mat-progress-bar
                    [mode]="'determinate'"
                    [value]="total() ? (processed() / total()) * 100 : 0"
                    [class.sign-off-time-transfer__progress-bar--done]="status() === TimeTransferStatus.DONE"
                ></mat-progress-bar>
            </div>
        }
    }

    <div class="sign-off-time-transfer__list-of-cards">
        @for (card of machineCards(); track card.deviceId) {
            <mat-card
                appearance="outlined"
                class="sign-off-time-transfer-card hdmui-p-4 hdmui-m-3"
                data-testid="sign-off-time-transfer-card"
            >
                <div>
                    <h1 class="hdmui-font-serif hdmui-m-0 sign-off-time-transfer-card__info-text">
                        {{ card.machine.machineName }}
                    </h1>
                    <h1 class="hdmui-font-bold hdmui-m-0">
                        {{ card.machine.machineId }}
                    </h1>
                </div>
                <div class="hdmui-my-4">
                    <div class="sign-off-time-transfer-card__entries">
                        @for (row of card.entries; track row.entry.id) {
                            <mat-card
                                class="hdmui-p-0 sign-off-time-transfer-entry-card"
                                [class.has-blue-indicator]="!row.transferred && !row.hasError"
                                [class.has-red-indicator]="row.hasError"
                                [class.is-transferred]="row.transferred && !row.hasError"
                                data-testid="sign-off-time-transfer-entry"
                            >
                                <data-terminal-time-mode-entry-card-content
                                    [entry]="row.entry"
                                    [activities]="activities()"
                                    [valuesOnly]="true"
                                />
                            </mat-card>
                        }
                    </div>
                </div>
                <div class="sign-off-time-transfer-card__status">
                    @switch (card.status) {
                        @case (TimeTransferStatus.DONE) {
                            <span class="sign-off-time-transfer-card__status--done">
                                <mat-icon svgIcon="hdmui:hookCircled"></mat-icon>
                                <span>{{ 'DC.SIGN_OFF_DIALOG.TIME_TRANSFER.CARD.DONE' | translate }}</span>
                            </span>
                        }
                        @case (TimeTransferStatus.ERROR) {
                            <span class="sign-off-time-transfer-card__status--error">
                                <mat-icon svgIcon="hdmui:xCircled"></mat-icon>
                                <span>{{ '*.error' | translate }}</span>
                            </span>
                        }
                        @case (TimeTransferStatus.TRANSFERRING) {
                            <span class="sign-off-time-transfer-card__status--transferring">
                                <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
                                <span>{{ 'DC.SIGN_OFF_DIALOG.TIME_TRANSFER.CARD.TRANSFERRING' | translate }}</span>
                            </span>
                        }
                    }
                </div>
            </mat-card>
        }
    </div>
</section>
